// importing React
import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// importing Icon
import PersonIcon from '@mui/icons-material/Person';
import GroupsIcon from '@mui/icons-material/Groups';
import GradeIcon from '@mui/icons-material/Grade';
import HomeIcon from '@mui/icons-material/Home';
import PublishIcon from '@mui/icons-material/Publish';
import CheckIcon from '@mui/icons-material/Check';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import TranslateIcon from '@mui/icons-material/Translate';
import ContactMailIcon from '@mui/icons-material/ContactMail';

import * as CONSTANTS from "../constants"

const drawerWidth = '15vw';
const drawerMinWidth = '210px'


export default ({lang, drawerOpen, setDrawerOpen}) => {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Effect to update the window width when resizing
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        // Add event listener for resize event
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []); // Empty dependency array means this runs once when the component mounts

    // Navigation
    const navigate = useNavigate();
    const navigateHome = () => {
        navigate(`/${lang}/`);
    }
    const navigateTermsExplained = () => {
        navigate(`/${lang}/terms-explained/`);
    }
    const navigateWazaren = () => {
        navigate(`/${lang}/wazaren/`);
    }
    const navigateWotageishi = () => {
        navigate(`/${lang}/wotageishi/`);
    }
    const navigateOrganization = () => {
        navigate(`/${lang}/organization/`);
    }
    const navigateMovement = () => {
        navigate(`/${lang}/movement/`);
    }
    const navigatePlace = () => {
        navigate(`/${lang}/place/`);
    }
    const navigateRequestTopic = () => {
        navigate(`/${lang}/request-topic/`);
    }
    const navigateApproveTopic = () => {
        navigate(`/${lang}/approve-topic/`);
    }
    const navigateContactUs = () => {
        navigate(`/${lang}/contact-us/`);
    }

    return (
        <Drawer
            variant={windowWidth > 780? "permanent": "temporary"}
            open={drawerOpen}
            onClose={()=> {setDrawerOpen(false)}}
            anchor={windowWidth > 780? "left": "top"}
            sx={{
                minWidth: drawerMinWidth,
                width:  windowWidth > 780? drawerWidth: "100%",
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: windowWidth > 780? drawerWidth: "100%", boxSizing: 'border-box', minWidth: drawerMinWidth},
            }}
        >
            <Toolbar />
            <Box sx={{ overflow: 'auto' }}>
                <Divider />
                <Divider />
                <List>
                    <ListItem key="Home" disablePadding>
                        <ListItemButton onClick={navigateHome}>
                            <ListItemIcon>
                                <HomeIcon />
                            </ListItemIcon>
                            <ListItemText primary={CONSTANTS.DRAWER.HOME[lang]} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key="Terms-Explained" disablePadding>
                        <ListItemButton onClick={navigateTermsExplained}>
                            <ListItemIcon>
                                <TranslateIcon />
                            </ListItemIcon>
                            <ListItemText primary={CONSTANTS.DRAWER.TERMS_EXPLAINED[lang]} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key="Contact-Us" disablePadding>
                        <ListItemButton onClick={navigateContactUs}>
                            <ListItemIcon>
                                <ContactMailIcon />
                            </ListItemIcon>
                            <ListItemText primary={CONSTANTS.DRAWER.CONTACT_US[lang]} />
                        </ListItemButton>
                    </ListItem>
                </List>
                <Divider />
                {/* Topic*/} 
                <List>
                    <ListItem key="Title">{CONSTANTS.DRAWER.TOPIC[lang].toUpperCase()}</ListItem>
                    <ListItem key="Wazaren" disablePadding>
                        <ListItemButton onClick={navigateWazaren}>
                            <ListItemIcon>
                                <GradeIcon />
                            </ListItemIcon>
                            <ListItemText primary={CONSTANTS.DRAWER.WAZAREN[lang]} />
                        </ListItemButton>
                    </ListItem>

                    <ListItem key="Wotageishi" disablePadding>
                        <ListItemButton onClick={navigateWotageishi}>
                            <ListItemIcon>
                                <PersonIcon />
                            </ListItemIcon>
                            <ListItemText primary={CONSTANTS.DRAWER.WOTAGEISHI[lang]} />
                        </ListItemButton>
                    </ListItem>

                    <ListItem key="Organization" disablePadding>
                        <ListItemButton onClick={navigateOrganization}>
                            <ListItemIcon>
                                <GroupsIcon />
                            </ListItemIcon>
                            <ListItemText primary={CONSTANTS.DRAWER.ORGANIZATION[lang]} />
                        </ListItemButton>
                    </ListItem>

                    <ListItem key="Movement" disablePadding>
                        <ListItemButton onClick={navigateMovement}>
                            <ListItemIcon>
                                <DirectionsRunIcon />
                            </ListItemIcon>
                            <ListItemText primary={CONSTANTS.DRAWER.MOVEMENT[lang]} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key="Place" disablePadding>
                        <ListItemButton onClick={navigatePlace}>
                            <ListItemIcon>
                                <LocationOnIcon />
                            </ListItemIcon>
                            <ListItemText primary={CONSTANTS.DRAWER.PLACE[lang]} />
                        </ListItemButton>
                    </ListItem>
                    <Divider variant="middle" />
                    <ListItem key="Request" disablePadding>
                        <ListItemButton onClick={navigateRequestTopic}>
                            <ListItemIcon>
                                <PublishIcon />
                            </ListItemIcon>
                            <ListItemText primary={CONSTANTS.DRAWER.REQUEST_TOPIC[lang]} />
                        </ListItemButton>
                    </ListItem>

                </List>
                <Divider />
                {/* Topic*/} 
                {
                    
                    localStorage.getItem('is_admin') == 'true'?
                    <>
                        <List>
                            <ListItem key="Title">{CONSTANTS.DRAWER.ADMIN[lang]}</ListItem>
                            <ListItem key="Wazaren" disablePadding>
                                <ListItemButton onClick={navigateApproveTopic}>
                                    <ListItemIcon>
                                        <CheckIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={CONSTANTS.DRAWER.APPROVE_TOPIC[lang]} />
                                </ListItemButton>
                            </ListItem>
                        </List>
                        <Divider />
                    </>   
                    :
                    <></>
                }
            </Box>
        </Drawer>
    );
}